module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_3016.987b4f5a.png";